(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 760px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initializeGallery = (gallery) => {
      if (gallery.dataset.galleryReady === 'true') return;

      const track = gallery.querySelector('[data-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const thumbsTrack = gallery.querySelector('.product-gallery__thumbs');
      const current = gallery.querySelector('[data-gallery-current]');

      if (!track || slides.length === 0) return;

      gallery.dataset.galleryReady = 'true';
      let activeIndex = 0;
      let hasActiveIndex = false;
      let frameId = 0;
      let resizeTimer = 0;
      let programmaticIndex = null;
      let programmaticTimer = 0;

      const setActive = (index) => {
        const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        if (hasActiveIndex && nextIndex === activeIndex) return;

        activeIndex = nextIndex;
        hasActiveIndex = true;
        if (current) current.textContent = String(activeIndex + 1);

        thumbs.forEach((thumb, thumbIndex) => {
          if (thumbIndex === activeIndex) {
            thumb.setAttribute('aria-current', 'true');
            if (mobileQuery.matches && thumbsTrack) {
              thumbsTrack.scrollTo({
                left: thumb.offsetLeft - (thumbsTrack.clientWidth - thumb.offsetWidth) / 2,
                behavior: reducedMotion.matches ? 'auto' : 'smooth'
              });
            }
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      };

      const nearestSlideIndex = () => {
        const left = track.scrollLeft;
        return slides.reduce((nearest, slide, index) => {
          const currentDistance = Math.abs(slide.offsetLeft - left);
          const nearestDistance = Math.abs(slides[nearest].offsetLeft - left);
          return currentDistance < nearestDistance ? index : nearest;
        }, 0);
      };

      const syncFromScroll = () => {
        if (programmaticIndex !== null) return;
        cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(() => setActive(nearestSlideIndex()));
      };

      const moveTo = (index, behavior = 'smooth') => {
        const target = slides[index];
        if (!target) return;
        programmaticIndex = index;
        setActive(index);
        track.scrollTo({
          left: target.offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : behavior
        });
        window.clearTimeout(programmaticTimer);
        programmaticTimer = window.setTimeout(() => {
          programmaticIndex = null;
          syncFromScroll();
        }, reducedMotion.matches || behavior === 'auto' ? 0 : 500);
      };

      track.addEventListener('scroll', syncFromScroll, { passive: true });
      track.addEventListener('pointerdown', () => {
        programmaticIndex = null;
        window.clearTimeout(programmaticTimer);
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (!mobileQuery.matches || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        moveTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => moveTo(Number(thumb.dataset.galleryIndex)));
      });

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          if (mobileQuery.matches) moveTo(activeIndex, 'auto');
        }, 120);
      });

      setActive(0);
    };

    const initializeSingleQuantity = (selector) => {
      if (selector.dataset.singleQuantityReady === 'true') return;

      const input = selector.querySelector('[data-single-quantity-input]');
      const minus = selector.querySelector('[data-single-quantity-minus]');
      const plus = selector.querySelector('[data-single-quantity-plus]');
      if (!input || !minus || !plus) return;

      selector.dataset.singleQuantityReady = 'true';
      const min = Math.max(1, Number(selector.dataset.quantityMin) || 1);
      const increment = Math.max(1, Number(selector.dataset.quantityIncrement) || 1);
      const max = selector.dataset.quantityMax ? Math.max(0, Number(selector.dataset.quantityMax)) : Infinity;
      const selectableMax = Number.isFinite(max)
        ? max < min ? 0 : min + Math.floor((max - min) / increment) * increment
        : Infinity;

      const normalize = (value) => {
        const parsed = Number.parseInt(value, 10);
        if (!Number.isFinite(parsed)) return min;
        const stepped = min + Math.round((parsed - min) / increment) * increment;
        return Math.min(selectableMax, Math.max(min, stepped));
      };

      const updateControls = (value) => {
        const parsed = Number.parseInt(value, 10);
        const quantity = Number.isFinite(parsed) ? normalize(parsed) : min;
        const unavailable = input.disabled;
        minus.disabled = unavailable || !Number.isFinite(parsed) || quantity <= min;
        plus.disabled = unavailable || quantity >= selectableMax;
      };

      const update = (value) => {
        if (selectableMax === 0) {
          input.value = '0';
          input.disabled = true;
          minus.disabled = true;
          plus.disabled = true;
          const submitButton = selector.closest('form')?.querySelector('button[name="add"]');
          if (submitButton) submitButton.disabled = true;
          return;
        }

        const quantity = normalize(value);
        input.value = String(quantity);
        updateControls(quantity);
      };

      minus.addEventListener('click', () => update(normalize(input.value) - increment));
      plus.addEventListener('click', () => update(normalize(input.value) + increment));
      input.addEventListener('input', () => update(input.value));
      input.addEventListener('change', () => update(input.value));
      update(input.value);
    };

    const initializeMultiVariantForm = (selector) => {
      if (selector.dataset.multiVariantReady === 'true') return;

      const form = selector.closest('form');
      const rows = Array.from(selector.querySelectorAll('[data-variant-row]'));
      const submitButton = form && form.querySelector('[data-multi-variant-add]');
      const submitLabel = submitButton && submitButton.querySelector('[data-multi-variant-label]');
      const selectedCount = selector.querySelector('[data-selected-count]');
      const selectedTotal = selector.querySelector('[data-selected-total]');
      const status = selector.querySelector('[data-multi-variant-status]');

      if (!form || !submitButton || rows.length === 0) return;

      selector.dataset.multiVariantReady = 'true';
      let isSubmitting = false;
      const numberFormatter = new Intl.NumberFormat('ja-JP');
      const hasAvailableVariants = rows.some((row) => row.querySelector('[data-quantity-input]'));

      const rowSettings = (row) => {
        const min = Math.max(1, Number(row.dataset.quantityMin) || 1);
        const increment = Math.max(1, Number(row.dataset.quantityIncrement) || 1);
        const max = row.dataset.quantityMax ? Math.max(0, Number(row.dataset.quantityMax)) : Infinity;
        const selectableMax = Number.isFinite(max)
          ? max < min ? 0 : min + Math.floor((max - min) / increment) * increment
          : Infinity;

        return { min, increment, selectableMax };
      };

      const normalizeQuantity = (row, value) => {
        const settings = rowSettings(row);
        const parsed = Number.parseInt(value, 10);
        if (!Number.isFinite(parsed) || parsed <= 0) return 0;

        const stepped = settings.min + Math.round((parsed - settings.min) / settings.increment) * settings.increment;
        return Math.min(settings.selectableMax, Math.max(settings.min, stepped));
      };

      const updateRow = (row, value) => {
        const input = row.querySelector('[data-quantity-input]');
        const minus = row.querySelector('[data-quantity-minus]');
        const plus = row.querySelector('[data-quantity-plus]');
        if (!input || !minus || !plus) return;

        const quantity = normalizeQuantity(row, value);
        const settings = rowSettings(row);
        input.value = String(quantity);
        input.readOnly = isSubmitting;
        row.classList.toggle('is-selected', quantity > 0);
        minus.disabled = quantity === 0 || isSubmitting;
        plus.disabled = quantity >= settings.selectableMax || isSubmitting;
      };

      const selections = () => rows.flatMap((row) => {
        const input = row.querySelector('[data-quantity-input]');
        const quantity = input ? normalizeQuantity(row, input.value) : 0;
        return quantity > 0 ? [{
          id: Number(row.dataset.variantId),
          quantity,
          price: Number(row.dataset.variantPrice) || 0
        }] : [];
      });

      const updateSummary = () => {
        const items = selections();
        const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
        const totalPrice = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

        if (selectedCount) selectedCount.textContent = `${numberFormatter.format(itemCount)}点`;
        if (selectedTotal) selectedTotal.textContent = `¥${numberFormatter.format(Math.round(totalPrice / 100))}`;
        submitButton.disabled = isSubmitting || !hasAvailableVariants || itemCount === 0;
        if (submitLabel && !isSubmitting) {
          submitLabel.textContent = !hasAvailableVariants
            ? selector.dataset.soldOutLabel
            : itemCount > 0 ? 'ショッピングバッグに追加' : 'サイズと数量を選択';
        }
      };

      rows.forEach((row) => {
        const input = row.querySelector('[data-quantity-input]');
        const minus = row.querySelector('[data-quantity-minus]');
        const plus = row.querySelector('[data-quantity-plus]');
        if (!input || !minus || !plus) return;

        minus.addEventListener('click', () => {
          const settings = rowSettings(row);
          const current = normalizeQuantity(row, input.value);
          updateRow(row, current <= settings.min ? 0 : current - settings.increment);
          updateSummary();
        });

        plus.addEventListener('click', () => {
          const settings = rowSettings(row);
          const current = normalizeQuantity(row, input.value);
          updateRow(row, current === 0 ? settings.min : current + settings.increment);
          updateSummary();
        });

        input.addEventListener('input', () => {
          updateRow(row, input.value);
          updateSummary();
        });

        updateRow(row, 0);
      });

      form.addEventListener('submit', async (event) => {
        if (isSubmitting) {
          event.preventDefault();
          return;
        }

        const liveName = form.querySelector('[data-product-live-name]')?.value.trim() || '';
        const items = selections().map(({ id, quantity }) => ({
          id,
          quantity,
          ...(liveName ? { properties: { _outo_live_name: liveName } } : {})
        }));
        if (items.length === 0) {
          event.preventDefault();
          updateSummary();
          return;
        }

        event.preventDefault();
        isSubmitting = true;
        selector.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';
        if (submitLabel) submitLabel.textContent = '追加しています…';
        rows.forEach((row) => updateRow(row, row.querySelector('[data-quantity-input]')?.value || 0));
        updateSummary();

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) throw new Error('Cart request failed');
          if (submitLabel) submitLabel.textContent = '追加しました';
          window.location.assign(selector.dataset.cartUrl || `${window.Shopify.routes.root}cart`);
        } catch (error) {
          isSubmitting = false;
          selector.removeAttribute('aria-busy');
          if (status) status.textContent = '追加できませんでした。数量と在庫をご確認のうえ、もう一度お試しください。';
          rows.forEach((row) => updateRow(row, row.querySelector('[data-quantity-input]')?.value || 0));
          updateSummary();
        }
      });

      updateSummary();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-product-gallery]').forEach(initializeGallery);
      scope.querySelectorAll('[data-single-quantity-selector]').forEach(initializeSingleQuantity);
      scope.querySelectorAll('[data-multi-variant-selector]').forEach(initializeMultiVariantForm);
    };

    initializeAll();
    window.addEventListener('pageshow', (event) => { if (event.persisted) window.location.reload(); });
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
